import SETTINGS from '../../constants/#SETTINGS';

const setSetting = (key: string, { namespace = SETTINGS.DEFAULT_NAMESPACE }: { namespace?: string } = {}) => {
  const setting = localStorage.getItem(`[${namespace}] ${key}`);

  if (setting === null && namespace !== SETTINGS.DEFAULT_NAMESPACE) {
    return localStorage.getItem(`[${SETTINGS.DEFAULT_NAMESPACE}] ${key}`);
  }

  return setting;
};

export default setSetting;
